"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _components = require("components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Thankyou = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(Thankyou, _React$Component);

  function Thankyou(props) {
    (0, _classCallCheck3.default)(this, Thankyou);
    return (0, _possibleConstructorReturn3.default)(this, (Thankyou.__proto__ || (0, _getPrototypeOf2.default)(Thankyou)).call(this, props));
  }

  (0, _createClass3.default)(Thankyou, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          _components.Popup,
          null,
          _react2.default.createElement(
            _components.Popup.Header,
            null,
            "THANK YOU FOR SUBSCRIBING"
          ),
          _react2.default.createElement(
            _components.Popup.Content,
            null,
            "We'll keep you posted on the latest product updates and news."
          )
        )
      );
    }
  }]);
  return Thankyou;
}(_react2.default.Component), _class.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp);
exports.default = Thankyou;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ThankyouPopup/Thankyou.jsx
// module id = 2855
// module chunks = 0